import React from "react"
import {withStyles} from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import MuiDialogActions from "@material-ui/core/DialogActions"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import AddEventForm from "./AddEventForm"
import {makeStyles, useTheme} from "@material-ui/core/styles"
import Zoom from "@material-ui/core/Zoom"
import Fab from "@material-ui/core/Fab"
import AddIcon from "@material-ui/icons/Add"

const styles = theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
})

const DialogTitle = withStyles(styles)(props => {
	const {children, classes, onClose, ...other} = props
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant='h6'>{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label='close'
					className={classes.closeButton}
					onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	)
})

const DialogContent = withStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent)

const DialogActions = withStyles(theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions)

const useStyles = makeStyles(theme => ({
	fab: {
		position: "absolute",
		bottom: theme.spacing(3.5),
		left: theme.spacing(5),
	},
}))

export default function ModalForm(props) {
	const [open, setOpen] = React.useState(false)

	const handleClickOpen = () => {
		setOpen(true)
	}
	const handleClose = () => {
		setOpen(false)
	}

	const classes = useStyles()
	const theme = useTheme()
	const [value, setValue] = React.useState(0)

	const transitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen,
	}

	const fabs = [
		{
			color: "primary",
			className: classes.fab,
			icon: <AddIcon />,
			label: "Add",
		},
	]

	return (
		<div>
			{fabs.map((fab, index) => (
				<Zoom
					key={fab.color}
					in={value === index}
					timeout={transitionDuration}
					style={{
						transitionDelay: `${
							value === index ? transitionDuration.exit : 0
						}ms`,
					}}
					unmountOnExit>
					<Fab
						aria-label={fab.label}
						className={fab.className}
						color={fab.color}
						onClick={handleClickOpen}>
						{fab.icon}
					</Fab>
				</Zoom>
			))}
			<Dialog
				onClose={handleClose}
				aria-labelledby='customized-dialog-title'
				open={open}>
				<DialogTitle id='customized-dialog-title' onClose={handleClose}>
					Добави Събитие
				</DialogTitle>
				<DialogContent dividers>
					<AddEventForm />
					{/* <AddUserForm
                        addEmployeeToState={this.props.addEmployeeToState}
                        updateState={this.props.updateState}
                        toggle={this.toggle}
                        employee={this.props.employee} /> */}
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose} color='primary'>
						Затвори
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}
